import { FeatureFlags } from '@bandido/shared/constants';

export const isInboxEnabled = (featureFlags?: readonly string[]) => featureFlags?.includes(FeatureFlags.Inbox) ?? false;

export const canUseInbox = (featureFlags: readonly string[] | undefined, canManageCases: boolean) =>
  isInboxEnabled(featureFlags) && canManageCases;

export const shouldOfferBrowserNotifications = (hasInboxAccess: boolean, isAgent: boolean) =>
  hasInboxAccess || isAgent;

export const parseInboxCaseId = (value?: string): number | null => {
  if (!value || !/^\d+$/.test(value)) return null;

  const caseId = Number(value);
  return Number.isSafeInteger(caseId) && caseId > 0 ? caseId : null;
};
